import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Context/AuthProvider";

const PrivateRoute = ({ children, permission }) => {
  // console.log(permission);
  const location = useLocation();
  const { auth } = useAuth();
  const loginStatus = auth["loginStatus"] === null ? null : auth["loginStatus"];
  var currentLoggedInUreRole = [];
  if (loginStatus !== null) {
    currentLoggedInUreRole = [auth.role.toString()];
  }
  // console.log(currentLoggedInUreRole);
  var Authorized;
  if (permission !== undefined) {
    Authorized = currentLoggedInUreRole?.filter((item) =>
      permission.includes(item)
    );
  }
  // console.log(Authorized);

  if (loginStatus === null) {
    return <Navigate to="/" state={{ path: location.pathname }} />;
  }
  if (permission !== undefined && Authorized.length == 0) {
    return <Navigate to="/404" state={{ path: location.pathname }} />;
  }

  return children;
};

export default PrivateRoute;
